import React, { useState, useEffect, useRef, useCallback } from 'react'
import './ShopItems.css'
import { useSelector, useDispatch } from 'react-redux'
import { Product, RingLoader, Dropdown } from '../../index'
import { getallProducts } from '../../../actions/productActions'
import Skeleton from '@mui/material/Skeleton'

const ShopItems = () => {
    const dispatch = useDispatch();
    const productState = useSelector(state => state.getallProducts);
    const { products, loading, hasMore, totalProducts } = productState;

    const [catOption, setCatOption] = useState('All Products');
    const [filteredProduct, setFilteredProduct] = useState([]);

    // Initialize page based on already-loaded products so re-navigation doesn't re-fetch
    const [page, setPage] = useState(() => products ? Math.ceil(products.length / 10) : 1);

    const observerRef = useRef(null);
    const sentinelRef = useRef(null);

    useEffect(() => {
        if (products !== null) {
            if (catOption === 'All Products') {
                setFilteredProduct([...products]);
            } else {
                setFilteredProduct(products.filter(item =>
                    item.category.toString().includes(catOption)
                ));
            }
        }
        if (window.history.state.usr !== null) {
            setCatOption(window.history.state.usr.category);
            window.history.state.usr = null;
        }
    }, [catOption, products]); // eslint-disable-line

    const loadMore = useCallback(() => {
        if (!loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            dispatch(getallProducts(nextPage));
        }
    }, [loading, hasMore, page, dispatch]);

    useEffect(() => {
        if (observerRef.current) observerRef.current.disconnect();
        observerRef.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        });
        if (sentinelRef.current) {
            observerRef.current.observe(sentinelRef.current);
        }
        return () => observerRef.current?.disconnect();
    }, [loadMore]);

    return (
        <>
            {products === null &&
                <section className='itemgallery'>
                    {Array.from({ length: 10 }).map((_, i) => (
                        <div key={i} className='productCard'>
                            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: '20px' }} />
                            <Skeleton width="60%" sx={{ margin: '1rem auto 4px' }} />
                            <Skeleton width="40%" sx={{ margin: '0 auto' }} />
                        </div>
                    ))}
                </section>
            }
            {products !== null ?
                <>
                    <nav className='shopItemNav'>
                        <Dropdown catOption={catOption} setCatOption={setCatOption} />
                        <div className='leftNav'>
                            <span>
                                {`Showing ${filteredProduct.length} of ${catOption === 'All Products' ? totalProducts : filteredProduct.length} products`}
                            </span>
                        </div>
                    </nav>
                    <section className='itemgallery'>
                        {filteredProduct.map((product, index) =>
                            <Product key={index} product={product} />
                        )}
                    </section>
                </>
                : ''
            }
            <div ref={sentinelRef} />
            {loading && <RingLoader />}
        </>
    );
}

export default ShopItems;
